import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel, FormControl, Select as MaterialSelect  ,Box ,TextField,
  FormControlLabel, LinearProgress, Checkbox, Typography,
RadioGroup, Radio, FormLabel} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import Modal from '../Generales/ModalTam';
import Rating from '@material-ui/lab/Rating';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const EditMaquina = ({modalAbierto,setModalAbierto,titulo,regis,funcionActuliza}) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [registro, setRegistro]= useState({Orden:0,Tipo:"",Status:'', Marca:"", Modelo:"", Ubicacion:"", Serie:"",
                                                    NoEco:"", Direccion:"", Alias:"", Descr:"", Nota:"",Seguro:""});  
  const {Orden, Tipo, Status, 
    Marca, Modelo, Ubicacion, Serie, NoEco, Direccion, Alias, Descr, Nota, Seguro
  }=registro    
  const [listStatus, setListStatus] = useState([])  
  const [listTipo, setListTipo] = useState([])  
  const [listMarca, setListMarca] = useState([])  
  const [listModelo, setListModelo] = useState([])  
  const [listModeloOriginal, setListModeloOriginal] = useState([])  
  const [listUbicacion, setListUbicacion] = useState([])  
  
  React.useEffect(()=>{     
   // console.log(regis);
    if (regis.length !== 0) {
      setRegistro({...registro, Tipo:regis.TpId, Status:regis.StId, Marca:regis.MarcaId, 
      Modelo:regis.ModelId, Ubicacion:regis.UbicId, Serie:regis.Serie,
      NoEco:regis.NoEco, Direccion:regis.Dir, Alias:regis.Descr, Orden:regis.Id,
      Descr:regis.Descr, Nota:regis.Notas, Seguro:`${regis.SegId}` })       
    }
    
 
    if (listStatus.length===0) 
    {
      getListStatus()
    } 
    
    getListTipo()
    getListMarca()
    getListModelo()
    getListUbicacion()

    return ()=> {
      source.cancel();
    }     
      // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

const getListStatus = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/status";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListStatus(aux);                                      
      }         
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  };  

  const getListTipo = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/tipo";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListTipo(aux);                                      
      }         
    }
    llamadaApiToken(data, url,respuesta,ErrorGeneral,history,source);
  };    

  const getListMarca = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/marca";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListMarca(aux);                                      
      }         
    }
    llamadaApiToken(data, url,respuesta,ErrorGeneral,history,source);
  };    

  const getListModelo = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/marca/modelo";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        let filtroModelo= aux.filter((model)=>model.Marca===regis.MarcaId )
        setListModelo(filtroModelo)    
        setListModeloOriginal(aux);                                      
      }         
    }
    llamadaApiToken(data, url,respuesta,ErrorGeneral,history,source);
  };    

  const getListUbicacion = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/ubicacion";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListUbicacion(aux);                                      
      }         
    }
    llamadaApiToken(data, url,respuesta,ErrorGeneral,history,source);
  };    

  const registrarNActividad=()=>{               
  
    //let NomUsu= localStorage.getItem('UsuarioNom');  
    const data = qs.stringify({
      Llave:Orden,
      Usuario:idusu,                  
      Tipo:Tipo,
      Status:Status,
      Marca:Marca,
      Modelo:Modelo,
      Ubicacion:Ubicacion,
      Serie:Serie,
      NoEco:NoEco,
      Lat:0.0,
      Lon:0.0,
      Dir:Direccion,
      Alias:Alias,
      Descr:Descr,
      Nota:Nota,
      IsSeguro:1,
      Seguro:Seguro,
      ip:"172.2.0.0",      
      idDispositivo:'8978yuhjnfrsdsd'
    });
    const url = "/maquinaria/new-edit";
  
    function respuesta(aux) {
      if (aux.respuesta==1) 
      { //console.log(aux);
        let mensaje= regis.length!==0 ?
        `Se edito correctamente el registro "${Descr} - ${Marca}" `        
        :`Se Registro correctamente la nueva maquinaria `
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)     
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });       
        funcionActuliza()
        setModalAbierto(false)            
      }   
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);     
  }

  const onChange = e =>
  { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if ((expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value) )||e.target.value===' '||e.target.value==='') 
    {
    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const onChangeDesc = e =>
  {      
    setRegistro({ ...registro, [e.target.name] : e.target.value })
    if (aviso) 
    {
      setMensaje('');
      setAviso(false);
    }    
  };

  
  const guardTerminal = e =>
  {
    setRegistro({ ...registro, [e.target.name] : e.target.value })
  };

  const onChangeMarca = e =>
  {   
    //console.log(e.target.value );
    
    if (e.target.value !==""&& e.target.value !==0) {
      let filtroModelo= listModeloOriginal.filter((model)=>""+model.Marca===""+e.target.value )
      //console.log(filtroModelo );
      setListModelo(filtroModelo)  
    }
    
    setRegistro({ ...registro, [e.target.name] : e.target.value,Modelo:"" })
  };

  const onChangeSeguro = e => {
    setRegistro({ ...registro, Seguro: e.target.value})
  };

  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    if (valor!= null && valor!= '' && valor!= '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    { setTipoAdvertencia("warning")    
      setMensaje(mensaje);
      setAviso(true)     
    }
    return respuesta
  }

  const guardarDatos = () => 
  {
    if (validaDatos(Status,"Seleccionar Estatus") && validaDatos(Tipo,"Seleccionar Tipo")) 
    { if ( validaDatos(Marca,"Seleccionar Marca") && validaDatos(Modelo,"Seleccionar Modelo") && validaDatos(Ubicacion,"Seleccionar Ubicación")) 
      { if ( ((Descr.length>=5 && validaDatos(Descr, "Llenar campo de Nombre (mayor a 5 caracteres)") ))
          || (Descr.length<5 && validaDatos(0, "Llenar campo de Nombre (mayor a 5 caracteres)"))
        ) 
        {
          registrarNActividad()                                                                           
        }   
      }         
    }                            
  };

  const onChangeRef = e =>
  { let expNopermitida = new RegExp('[$!?]');
    //let expMenos = new RegExp('-');
    //let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9#_:%-({})/*=|]');
    if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) ) 
        || e.target.value===' ' || e.target.value==='') 
    {    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const cambioActualiza = (event) => {
    setRegistro({...registro, [event.target.name]: event.target.checked });
  };

  const guardarPrioridad = (event) => {
    //console.log(event);
    if (event) {      
      setRegistro({ ...registro, Prioridad : event  })
    }
    else
    {
      setRegistro({...registro,Prioridad : 0})
      //console.log('sin guardar vacio');
    }
    
  };
  
  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} 
    setEspera={setEspera}  tamanio={"md"} btnDesact={btnDesact}
  >
  <form className={classes.root} noValidate autoComplete="off" fullWidth style={{width:30+'rem'}} >                               
    <Box display={"flex"} flexDirection={"row"}>
    {listStatus.length!==0 ?  
      <Box display="flex" flexDirection="row" mr={2}>        
        <FormControl className={classes.formControl} size="small" style={{width:12+'rem'}}>
          <InputLabel htmlFor="age-native-simple">Estatus</InputLabel>
          <MaterialSelect
            native value={Status}  onChange={guardTerminal}
            inputProps={{ name: 'Status', id: 'Status', }}            
          >
            <option aria-label="None" value="" />      
            {listStatus.map((row) => (
                <option value={row.Id}>{row.Descr}</option>
            ))}   
          </MaterialSelect>
        </FormControl>             
      </Box> 
      :<LinearProgress color="primary" />}    
      {listTipo.length!==0 ?  
       <Box display="flex" flexDirection="row">        
        <FormControl className={classes.formControl} size="small" style={{width:14+'rem'}}>
          <InputLabel htmlFor="age-native-simple">Tipo</InputLabel>
          <MaterialSelect
            native value={Tipo}  onChange={guardTerminal}
            inputProps={{ name: 'Tipo', id: 'Tipo', }}            
          >
            <option aria-label="None" value="" />      
            {listTipo.map((row) => (
                <option value={row.Id}>{row.Descr}</option>
            ))}   
          </MaterialSelect>
        </FormControl>             
      </Box> 
      :null}   
    </Box>
    <Box display={"flex"} flexDirection={"row"}>
      {listMarca.length!==0 ?  
       <Box display="flex" flexDirection="row" mr={2}>        
        <FormControl className={classes.formControl} size="small" style={{width:13+'rem'}}>
          <InputLabel htmlFor="age-native-simple">Marca</InputLabel>
          <MaterialSelect
            native value={Marca}  onChange={onChangeMarca}
            inputProps={{ name: 'Marca', id: 'Marca', }}            
          >
            <option aria-label="None" value="" />      
            {listMarca.map((row) => (
                <option value={row.Id}>{row.Descr}</option>
            ))}   
          </MaterialSelect>
        </FormControl>                     
      </Box> 
      :null}   
      {listModelo.length!==0 ?  
       <Box display="flex" flexDirection="row">        
        <FormControl className={classes.formControl} size="small" style={{width:13+'rem'}}>
          <InputLabel htmlFor="age-native-simple">Modelo</InputLabel>
          <MaterialSelect
            native value={Modelo}  onChange={guardTerminal}
            inputProps={{ name: 'Modelo', id: 'Modelo', }}            
          >
            <option aria-label="None" value="" />      
            {listModelo.map((row) => (
                <option value={row.Id}>{row.Descr}</option>
            ))}   
          </MaterialSelect>
        </FormControl>                     
      </Box> 
      :null}   
      </Box>
      <Box display={"flex"} flexDirection={"row"}>
        {listUbicacion.length!==0 ?  
        <Box display="flex" flexDirection="row">        
          <FormControl className={classes.formControl} size="small" style={{width:20+'rem'}}>
            <InputLabel htmlFor="age-native-simple">Ubicación</InputLabel>
            <MaterialSelect
              native value={Ubicacion}  onChange={guardTerminal}
              inputProps={{ name: 'Ubicacion', id: 'Ubicacion', }}            
            >
              <option aria-label="None" value="" />      
              {listUbicacion.map((row) => (
                  <option value={row.Id}>{row.Descr}</option>
              ))}   
            </MaterialSelect>
          </FormControl>                     
        </Box> 
        :null} 
       
      </Box>     
      <Box >
        <FormControl component="fieldset"  style={{width:'18rem'}}>
          <FormLabel component="legend" size="small" >Seguro</FormLabel>
          <RadioGroup row aria-label="position" 
            name="Seguro" value={Seguro} onChange={onChangeSeguro}
          >
            <FormControlLabel value="0" style={{color: '#F46239'}} 
              control={<Radio color="primary" size="small"/>} label="Sin Asegurar"/>
            <FormControlLabel value="1" style={{color: '#049b4f'}} 
              control={<Radio color="primary" size="small"/>} label="Asegurado"/>            
          </RadioGroup>
        </FormControl>
        </Box> 
      <TextField id="outlinedNoEco" variant='outlined'                     
        label="No. Economico"  size="small"
        value={NoEco} onChange={onChangeRef}  
        name="NoEco" style={{width:13.5+'rem'}}                                               
      /> 
      <TextField id="outlinedSerie" variant='outlined'           
        label="Serie"  size="small"
        value={Serie} onChange={onChangeRef}  
        name="Serie" style={{width:13.5+'rem'}}                                               
      /> 
      <br/>  
      <Box style={{width:30+'rem'}}>      
      <FormControl component="fieldset" style={{width:28+'rem'}}>    
        <TextField id="outlinedDescr" variant='outlined'           
          label="Nombre"  size="small"
          value={Descr} onChange={onChangeRef}  
          name="Descr" fullWidth
        /> 
      </FormControl>
      </Box>
     {/*  <br/>
        <FormControlLabel
          control={<Checkbox checked={Finaliza} onChange={cambioActualiza} name="Finaliza" />}
          label="Finaliza"
        />
      
      <br/>
      {Finaliza?
      <textarea id="Solucion-TextArea" name="Solucion" rows="5"
          cols="100"placeholder="Solución" style={{width: 33.2+"rem",borderRadius:3+'px'}} 
          value={Solucion} onChange={onChange} 
        />:null} */}
      </form>
  </Modal>
  );
}
 
export default EditMaquina;